<script>
  import { onMount } from 'svelte';
  import { getApiUrl } from '../api';
  import { authFetch } from '../authService';

  let questionText = '';
  let allQuestions = [];
  
  let isLoading = false;
  let error = '';
  let successMessage = '';

  onMount(() => {
    fetchQuestions();
  });

  async function fetchQuestions() {
    isLoading = true;
    try {
      const response = await authFetch(getApiUrl('/questions'));
      if (!response.ok) throw new Error('Could not fetch existing questions.');
      allQuestions = await response.json();
    } catch (e) {
      error = e.message;
    } finally {
      isLoading = false;
    }
  }

  async function handleSubmit() {
    isLoading = true;
    error = '';
    successMessage = '';

    if (!questionText.trim()) {
      error = 'Question text cannot be empty.';
      isLoading = false;
      return;
    }

    try {
      const response = await authFetch(getApiUrl('/admin/questions'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ question: questionText }),
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.error || 'Failed to add question.');
      }
      
      successMessage = 'Question added successfully!';
      questionText = ''; // Clear form
      fetchQuestions(); // Refresh the list

    } catch (e) {
      error = e.message;
    } finally {
      isLoading = false;
    }
  }
</script>

<div class="maintenance-container">
  <h2>Question Maintenance</h2>
  
  <div class="form-section">
    <h3>Add a New Profile Question</h3>
    <p>Create a new question that will be shown to members on their profile page.</p>
    <form on:submit|preventDefault={handleSubmit}>
      <div class="form-group">
        <label for="question-text">Question</label>
        <input type="text" id="question-text" bind:value={questionText} placeholder="e.g., What is your favorite hobby?" />
      </div>
      <button type="submit" disabled={isLoading}>
        {#if isLoading}Adding...{:else}Add Question{/if}
      </button>
      {#if error}<p class="error">{error}</p>{/if}
      {#if successMessage}<p class="success">{successMessage}</p>{/if}
    </form>
  </div>

  <div class="list-section">
    <h3>Existing Questions</h3>
    {#if isLoading}
      <p>Loading questions...</p>
    {:else if allQuestions && allQuestions.length > 0}
      <ul>
        {#each allQuestions as q (q._id)}
          <li>{q.question}</li>
        {/each}
      </ul>
    {:else}
      <p>No questions have been created yet.</p>
    {/if}
  </div>
</div>

<style>
  .maintenance-container {
    max-width: 800px;
    margin: 2rem auto;
    text-align: left;
  }

  .form-section, .list-section {
    background: #fff;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.05);
    margin-bottom: 2rem;
  }
  
  form { display: flex; flex-direction: column; gap: 1rem; }
  .form-group { margin-bottom: 1rem; }
  label { display: block; margin-bottom: 0.5rem; font-weight: 500; }
  input { width: 100%; padding: 0.75rem; border: 1px solid #ccc; border-radius: 4px; font-size: 1rem; box-sizing: border-box; }
  button { padding: 0.75rem; background-color: #007bff; color: white; border: none; border-radius: 4px; font-size: 1.1rem; cursor: pointer; }
  button:disabled { background-color: #aaa; }
  
  ul {
    list-style-type: disc;
    padding-left: 20px;
  }
  
  li {
    padding: 8px 0;
    border-bottom: 1px solid #eee;
  }
  
  .error { color: red; }
  .success { color: green; }
</style>
